import { LocationChange } from '@provider-portal/common/services/ProviderPortalNavigationService';

import { GlobalAppState } from 'root/rdx/state';

export const urlLocationAdapter = (globalState: GlobalAppState): LocationChange => ({
  pathname: globalState.router.location.pathname,
  search: globalState.router.location.search,
  hash: globalState.router.location.hash,
});
